<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >上账</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="租户总户上账"
      width="500px"
      @close="closeDialog"
    >
      <el-form :model="detail" ref="form" :rules="rules" label-width="100px">
        <el-form-item label="租户：" prop="tenantId">
          <el-select v-model="detail.tenantId" placeholder="请选择租户" clearable>
            <el-option
              v-for="item in tenantList"
              :key="item.id"
              :label="item.tenantName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="币种：" prop="coin">
          <el-select v-model="detail.coin" placeholder="请选择">
            <el-option
              v-for="item in coinList"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上账金额：" prop="amount">
          <el-input-number
            v-model="detail.amount"
            :min="0.00000001"
            :controls="false"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSave('form')"
          >确定上账</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "TransferInnerCreate",
  props: {
    tenantList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogVisible: false,
      detail: {},
      rules: {
        tenantId: {
          required: true,
          message: "请选择租户",
          trigger: "change",
        },
        coin: {
          required: true,
          message: "请选择币种",
          trigger: "change",
        },
        amount: {
          required: true,
          message: "请输入上账金额",
          trigger: "blur",
        },
      },
    };
  },
  computed: {
    ...mapState("ctf", ["coinList"]),
  },
  mounted() {
    this.listAllCoin();
  },
  methods: {
    ...mapActions("transferInner", ["transfer", "reqList"]),
    ...mapActions("ctf", ["listAllCoin"]),
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {};
      this.$refs["form"].resetFields();
    },
    close() {
      this.dialogVisible = false;
      this.detail = {};
      this.$refs["form"].resetFields();
    },
    handleSave() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const res = await this.transfer({ ...this.detail });
          if (res.code == 0) {
            this.$message({
              message: "上账成功！",
              type: "success",
            });
            this.$emit("refresh", { page: 1 });
            this.close();
          }
        }
      });
    },
  },
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
